<template>
  <b-modal id="communities-modal" title="Find Community" hide-footer>
      <p>Search for a community to join.</p>
      <base-input label="Community:" label-for="community" name="Community">
        <el-select filterable v-model="community_id">
          <el-option v-for="community in communities"
                     :key="community.id"
                     :label="community.name"
                     :value="community.id">
          </el-option>
        </el-select>
      </base-input>
      <b-button block variant="danger" @click="joinCommunity">Join Community</b-button>
    </b-modal>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { Select, Option } from 'element-ui';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      communities: [],
      community_id: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
      userCommunities: 'communities/communities'
    })
  },
  methods: {
    async getCommunities() {
      await axios.get(this.userRoute + "/get-communities")
      .then(response => {
        this.communities = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async joinCommunity() {
      await axios.post(this.userRoute + "/communities/join", {
        community_id: this.community_id
      })
      .then(response => {
        this.community_id = null;
        this.$store.dispatch("communities/get", {user: this.user.slug});
        this.$bvModal.hide('communities-modal');
      })
      .catch(error => {
        // 
      });
    }
  },
  watch: {
    userCommunities(to, from) {
      this.getCommunities();
    }
  },
  created() {
    this.getCommunities();
  }
};
</script>